import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { ContactSupport, ContactSupportQueryParams } from "../types";

interface ContactSupportState {
  contactSupports: Array<ContactSupport>;
  contactSupportsTotal: number;
  contactSupport?: ContactSupport;
}

const initialState: ContactSupportState = {
	contactSupports: [],
	contactSupportsTotal: 0,
};

export const contactSupportSlice = createSlice({
	name: "contactSupport",
	initialState,
	reducers: {
		setContactSupports: (state, action) => {
			state.contactSupports = action.payload.data;
			state.contactSupportsTotal = action.payload.total;
		},
		setContactSupport: (state, action) => {
			state.contactSupport = action.payload.data;
		},
		changeStatusContactSupport: (state, action) => {
			const { id, status } = action.payload;
			const index = state.contactSupports.findIndex(el => el.id === id);
			state.contactSupports[index].status = status;
		},
	},
});

export const selectContactSupports = (state: RootState) => state.contactSupport.contactSupports;
export const selectContactSupportsTotal = (state: RootState) => state.contactSupport.contactSupportsTotal;
export const selectContactSupport = (state: RootState) => state.contactSupport.contactSupport;

export const { setContactSupports, setContactSupport, changeStatusContactSupport } = contactSupportSlice.actions;

export interface GetContactSupportsAsyncPayload {
  query: ContactSupportQueryParams;
	callback?: () => void;
}
export interface GetContactSupportDetailsPayload {
  id: string;
	callback: () => void;
}

export interface UpdateContactSupportPayload {
  id?: number;
  status?: string;
	note?: string;
	caringStaffId?: number;
	callback?: () => void;
}

export const getContactSupportsAsync = createAction(
	"contactSupport/getContactSupports",
	(payload: GetContactSupportsAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getContactSupportDetailsAsync = createAction(
	"contactSupport/getContactSupportDetails",
	(payload: GetContactSupportDetailsPayload) => ({
		payload: payload,
	})
);

export const updateContactSupportAsync = createAction(
	"contactSupport/updateContactSupport",
	(payload: UpdateContactSupportPayload) => ({
		payload: payload,
	})
);

export default contactSupportSlice.reducer;
